import * as cookie from '../utils/cookie'

export const systemName = '一溜OS'
export const systemCompany = 'ipf'
export const systemVersion = '1.0.0.0'
export const layout = 1 // 整体布局： 1：模块->菜单， 2：菜单
export const thumb = 0 // 菜单样式： 0：非缩略图模式， 1：缩略图标模式
export const mode = 'server' // 模式：local（从menu.js、dict.js中获取菜单和字典资源）， server（从服务器中获取菜单和字典资源）

export const api_url = process.env.VUE_APP_API_URL
export const app_key = process.env.VUE_APP_APP_KEY
export const app_secret = process.env.VUE_APP_APP_SECRET
export const client_version = '1.0.0.0'
export const client_lang = 'zh_CN'
export const extra = {}
export const timeout = 60000
export const file_url = process.env.VUE_APP_FILE_URL

export const map_key = 'eb1206b9fbe7505fbd947bf704ec3419'
export const map_secret = '1eb334cb9f544f64647bf280a0a119fa'

export function getAccessToken () {
  // js: null/undefined/0/NaN/""表达式时，统统被解释为false,此外均为true
  // 在js中  == 情况下 null == undifined return true   null ==== undifined return false Nan特立独行 永远不与任何值相等，包括它本身
  const access_token = cookie.get('access_token')
  if (!access_token || access_token === 'null' || access_token.trim().length === 0) {
    return null
  }
  return cookie.get('access_token')
}

export function setAccessToken (value) {
  // 特殊处理: cookie设置为null的时候，变成了null串
  if (value == null || value === '') {
    cookie.remove('access_token')
  } else {
    cookie.set('access_token', value)
  }
}

export function getLinkId () {
  // js: null/undefined/0/NaN/""表达式时，统统被解释为false,此外均为true
  // 在js中  == 情况下 null == undifined return true   null ==== undifined return false Nan特立独行 永远不与任何值相等，包括它本身
  const link_id = cookie.get('link_id')
  if (!link_id || link_id === 'null' || link_id.trim().length === 0) {
    return null
  }
  return cookie.get('link_id')
}

export function setLinkId (value) {
  // 特殊处理: cookie设置为null的时候，变成了null串
  if (value == null) {
    cookie.remove('link_id')
  } else {
    cookie.set('link_id', value)
  }
}